/* ════ CHANGELOG (shown in the What's new modal) ═══════════ */
export const CHANGES = [
  { v: 'v1.45', items: ['Tidier top bar on every screen size', 'Small fixes and improvements'] },
  { v: 'v1.44', items: ['Small fixes and improvements'] },
  { v: 'v1.43', items: [
    'Sign in with Microsoft: a button on the login screen for red10 Microsoft accounts (appears once it\'s switched on); your existing account, lane and leave carry over',
  ] },
  { v: 'v1.42', items: [
    'While you were away: on opening GRANTT, a summary of what other people added or changed on your lane, new Inbox cards, cards you\'ve been flagged on, and leave news since your last visit; click any item to open it',
    'Reopen it from More → What you missed',
    'Fix: flagging teammates on Inbox cards now saves properly',
  ] },
  { v: 'v1.41', items: [
    'Tidier top bar: Export, Import, Resources, What\'s new and Dark mode are under More (top right)',
    'On smaller screens the date controls sit on their own row instead of wrapping untidily',
  ] },
  { v: 'v1.39', items: [
    'Bank holidays come off the annual leave allowance (from your start date), matching HR\'s leave records; the approver can switch this in Allowances',
    'Balances, the request form, request cards, records and emails all count them the same way',
  ] },
  { v: 'v1.38', items: [
    'My record: your own leave record (leave, bank holidays, time in lieu, running balance), visible only to you and HR',
    'HR records: a per-person record like the leave spreadsheet, with sickness, medical, time in lieu, other absence and leave adjustments; notes are encrypted',
    'Allowances: contract days plus pro-rata for people who join part-way through a year',
    'Declining a request needs a reason and can suggest other dates, which the person can request in one click',
    'Approval messages say how many days you have left; Will can view leave and records (view only)',
  ] },
  { v: 'v1.37', items: [
    'The Today button now sits with the ‹ › date navigation',
  ] },
  { v: 'v1.36', items: [
    'Leave totals for this year and next: the avatar menu and My leave show both, so you can book next year\'s holiday and see what\'s left',
    'Approver: the Allowances tab shows both years side by side, with one click to copy this year\'s allowances into next year',
  ] },
  { v: 'v1.35', items: [
    'Seasonal touches 🎃🎆🎄 on the planner: Halloween (pumpkin, cobweb, a bat), Bonfire Night and New Year\'s Eve fireworks, Christmas (tree, presents, fairy lights all December, snow in Christmas week), Valentine\'s, Pancake Day, Easter and the first day of autumn',
    'Birthdays 🎂: add day + month in Resources and that person gets confetti the first time they open GRANTT on the day',
    'A 🌴 on your own lane on your last working day before approved leave, with a “enjoy your break” message on the day',
    'Switch decorations off any time: avatar menu → ✨ Seasonal decorations',
  ] },
  { v: 'v1.34', items: [
    'Confetti 🎉 when you send a leave request (with palm trees and sunshine) or send tasks to invoicing (with pound notes)',
    'The send button turns green and confirms “Sent” before the form closes',
    'A retro 8-bit “level up!” 🕹️ jingle (and confetti) if your leave is approved while you have GRANTT open',
    'A little number on your avatar when there\'s leave news: your requests approved or declined since you last looked, and (for the approver) requests to review',
  ] },
  { v: 'v1.33', items: [
    'Requested leave shows straight away as a striped ⏳ “pending” block on your planner lane, so the team can see it',
    'Approving turns it into the normal Annual Leave block; declining or cancelling removes it',
    'The approver\'s request email now lists anyone else who\'s off on those dates (and says so in the subject)',
  ] },
  { v: 'v1.32', items: [
    'Leave emails — the approver is emailed when someone requests or cancels leave',
    'You get an email when your leave is approved (with your balance) or declined (with the reason)',
  ] },
  { v: 'v1.31', items: [
    'Annual leave — request holiday from your avatar menu, with a live day count (weekends & UK bank holidays excluded)',
    'Your leave balance in the avatar menu; “My leave” lists your requests and lets you cancel',
    'Leave approver: a Leave tab to approve or decline requests and set each person\'s yearly allowance',
    'Approved leave appears on the planner automatically; cancelling puts the days back',
  ] },
  { v: 'v1.30', items: [
    '“🧾 To invoice” preset button — one click sets External + not-invoiced and opens the List',
  ] },
  { v: 'v1.29', items: [
    'Invoicing filter on the Planner & List — To invoice / Ready to invoice / Invoiced; combine with Category: External for the “to be invoiced” worklist',
  ] },
  { v: 'v1.28', items: [
    'Category chips wrap into tidy pills (no more squashing as you add categories)',
    'Deleting a category safely moves any cards using it to “None” (with a count)',
  ] },
  { v: 'v1.27', items: [
    'Custom categories — add your own (name, colour, emoji) via the ＋ on any card’s category row; they colour the planner, list, Inbox, filter & legend',
  ] },
  { v: 'v1.26', items: [
    'One-click “Mark invoiced” button in the invoice email — flips exactly those tasks to Invoiced (via a new mark-invoiced function)',
  ] },
  { v: 'v1.25', items: [
    'Clearer invoice-send feedback — a failed send now shows the real reason (missing key, unverified domain, etc.)',
  ] },
  { v: 'v1.24', items: [
    '“Send to invoicing” button — emails ONE summary of all Ready-but-not-Invoiced tasks (with total); ticking Ready no longer sends per-task',
  ] },
  { v: 'v1.23', items: [
    'Invoicing tick boxes — “Ready to invoice” & “Invoiced” on each List row and in the task editor',
    'By-client totals now show cost as well as hours',
    'Flagging a task “ready to invoice” can email your invoice inbox (needs the notify-invoice function deployed)',
  ] },
  { v: 'v1.22', items: [
    'List view now totals hours per client (below the cost total), following the current filters & search',
  ] },
  { v: 'v1.21', items: [
    'Cost column on the List view, with a running total at the bottom that follows the current filters & search',
  ] },
  { v: 'v1.20', items: [
    'Search now covers the whole card — client, team, notes, tags, resource, role, subtasks, not just the title',
    'Clicking a List-view row reliably opens its job card (no more accidental text selection)',
  ] },
  { v: 'v1.19', items: [
    'How-it\'s-calculated table on the CO₂ board — official factors, zone→haul mapping, distances and the formula',
  ] },
  { v: 'v1.18', items: [
    'Recalc flights button — updates previously-imported flights to the current official CO₂ factors in one click',
  ] },
  { v: 'v1.17', items: [
    'CO₂ board mode filters — show/hide flights, hotels, cars, trains (totals & graph follow the filter)',
    'Deleting an imported trip stops it re-importing next week (previously-removed events stay out)',
  ] },
  { v: 'v1.16', items: [
    'Flights use official UK Gov 2026 GHG factors (business class, to/from UK) × distance',
    'Per-flight distance field (defaults per haul, editable); calendar import ticks flights by default',
  ] },
  { v: 'v1.15', items: [
    'CO₂ target — set an annual target and see a monthly graph against your budget (over-budget months in red)',
    'Calendar re-imports de-duped — events already imported are recognised and skipped, so only new trips come in',
  ] },
  { v: 'v1.14', items: [
    'Import calendar CSV on the CO₂ board — auto-detects travel, estimates carbon, review then place trips',
  ] },
  { v: 'v1.13', items: [
    'CO₂ board — a travel gantt: draw trips onto the timeline with a mode, zone and carbon figure',
    'CO₂ auto-estimate from mode × zone (overridable), plus a total report by mode / zone / person and CSV export',
  ] },
  { v: 'v1.12', items: [
    'Costs dashboard — a Costs tab totalling task costs for a person over a date range, with per-person bars, quick presets and CSV export',
  ] },
  { v: 'v1.11', items: [
    'Cost (£) on tasks — shown on the planner block and in the tooltip',
    'Export → Costs tab — totals costs by the current filters, broken down by client / team / resource',
    'Flag a teammate to review an Inbox card — a dedicated 🔔 counter, a nudge, and the Inbox opens on “Flagged for me”',
  ] },
  { v: 'v1.10', items: [
    'Resource roles — assign a role (Consultant, Designer, …) in Resources and filter the planner & list by role',
  ] },
  { v: 'v1.9', items: [
    'Auto resources — signing in for the first time creates your planner lane automatically (links to a same-named lane if one exists)',
  ] },
  { v: 'v1.8', items: [
    'Private tasks & Inbox cards — creator & assignee see full detail, everyone else sees a redacted “Private” block',
    '✨ What’s-new button on the toolbar listing every change',
    'Inbox cards can be locked (protected from bulk delete); subtasks & lock moved to the top to match the task card',
  ] },
  { v: 'v1.7', items: [
    'Skip-weekends toggle — scheduled durations count working days (tasks extend over weekends)',
    'Hide-done filter on the planner & list; tasks auto-complete when every subtask is ticked',
    'Hours report moved under Export (Tasks / Hours-by-client tabs)',
  ] },
  { v: 'v1.6', items: [
    'Mark tasks Complete (tickbox next to Lock); completed tasks dimmed/struck through',
    'Task editor tidied — subtasks moved up under Lock/Complete',
  ] },
  { v: 'v1.5', items: [
    'MS Planner import — export a plan to Excel and import it from the toolbar',
    'CSV export field picker + date range',
  ] },
  { v: 'v1.4', items: [
    'Real red10 logo artwork; whole palette aligned to the brand red',
    'Client & Team filters, coloured category pills, hours, Inbox due dates + filtering',
  ] },
  { v: 'v1.3', items: [
    'Assignment alerts (resource → login email); persistent History tab',
    'Client field; “Schedule” suggests the next free slot',
  ] },
  { v: 'v1.2', items: [
    'Custom tags; per-user inboxes with a user picker; Inbox sort / filter / group-by-tag',
    'Split a subtask into a new card',
  ] },
  { v: 'v1.1', items: [
    'Supabase Auth (set/change/forgot password, add users)',
    'Planner resize, drag-past-edge, half-days; List view; Inbox bulk edit; lock; undo; dark mode',
  ] },
];

export function changelogHtml() {
  return CHANGES.map(c => `
    <div class="cl-entry">
      <div class="cl-ver">${c.v}</div>
      <ul class="cl-list">${c.items.map(i => `<li>${i}</li>`).join('')}</ul>
    </div>`).join('');
}
